import * as React from 'react';
import * as style from './ReviewsTeaserLayout.css';

export const ReviewsTeaserLayout = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <section data-nav-tab="reviews/Отзывы" id="reviews" className={style['wrapper']}>
      {children}
    </section>
  );
};
